import { Refresh } from '@browser/Browser';
import { generateName } from "@common/Common";
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { guid } from "@common/Guid";
import { CloneCorporateScenarioCommandV1, CreateCorporateScenarioCommandV1, DeleteCorporateScenarioCommandV1, UpdateCorporateScenarioCommandV1 } from '@Quest/CorporateScenarios/Domain/commands-core';
import CorporateScenariosCommands from '@Quest/CorporateScenarios/Domain/commands-vue-component';
import CorporateScenariosQueries from '@Quest/CorporateScenarios/Domain/queries-vue-component';
import { CorporateScenarioReadModel, ScenariosPageReadModel } from '@Quest/CorporateScenarios/Domain/readmodels';
import { ICommandBase } from '@Quest/cqrs';
import moment from "moment";
import Component, { mixins } from 'vue-class-component';

@Component({ components: { CorporateNavigation }})
export default class ScenariosPage extends mixins(CorporateScenariosCommands, CorporateScenariosQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: ScenariosPageReadModel | null = null;


    formatDate(date: Date | null)
    {
        if (date == null) return null;
        return moment(date).format('MMM D, YYYY')
    }

    formatTime(date: Date | null)
    {
        if (date == null) return null;
        return moment(date).format('LT');
    }

    handleCloneCorporateScenarioCommand(s: CorporateScenarioReadModel)
    {
        this.invokeCloneCorporateScenarioCommandV1(this.workspaceId, this.strategyId, s.Id, guid(), generateName(s.Name));
    }

    handleDeleteCorporateScenarioCommand(scenarioId: string)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteCorporateScenarioCommandV1(this.workspaceId, this.strategyId, scenarioId);
        }
    }

    mounted()
    {
        document.title = "Enterprise Plans";
        this.runScenariosPageQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "ScenariosPageReadModel")
        {
            this.rm = model as ScenariosPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateCorporateScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (UpdateCorporateScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (CloneCorporateScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (DeleteCorporateScenarioCommandV1.matchType(cmd))
        {
            this.rm!.Scenarios = this.rm!.Scenarios.filter(a => a.Id !== correlationId);
        }
    }
}